import React, {
  useState,
  useEffect,
  useRef
} from 'react';

import
  PropTypes
from 'prop-types';

import {
  VettingDownArrow,
  VettingGreenTick,
  VettingErrorIcon
} from 'src/Components/Common/Svg'

import './VettingDropDown.css';

const VettingDropDown = (props) => {

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [showptions, setShowoptions] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(props.options);

  useEffect(() => {

    setFilteredOptions(

      props?.options?.filter(option =>
        option?.toLowerCase()?.includes(searchTerm?.toLowerCase())
      )
    );
  }, [searchTerm, props.options]);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowoptions(false);
        }
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  const updateSelectedOption = (option, inputIdentifier) => {
  
    setShowoptions(!showptions);
    props.updateSelectedOption(option, inputIdentifier);
  }

  return (

    <div ref={wrapperRef} style={{ width: '100%' }}>

      <div className="vetting-select-wrapper">

        <div
          className={`vetting-dropdown-option-container ${props.extraClass ? 'disableDropDown' : ''} ${props.addClass || ''}`}
          onClick={() => setShowoptions(!showptions)}>

          <p className={'vetting-current-option'}>

            { props.selectedValue ? props.selectedValue : (props.genderFromID ? props.genderFromID : <span style={{ color: '#cccccc' }}>{props.placeholder}</span>) }
          </p>

          <p className="vetting-arrow-icons-wrapper">

            <VettingDownArrow
              direction={showptions ? 'vetting-icon-chevron-up' : 'vetting-icon-chevron-down'} />
          </p>
        </div>
      </div>

      { (!props.isValid && props.isTouched)

        ? <span className={`vetting-invalid-msg-wrapper ${props.width <= 50 ? 'width200' : ''}`}>
          <VettingErrorIcon />

          <span className="vetting-invalid-msg">

            {props.validations.invalidMessage}
          </span>
        </span>

        : null
      }

      {/* Options */}

      { showptions
        ? <div className="vetting-all-options">

          { props.isSearchable &&

            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="vetting-search-input"
            />
          }
          
          { filteredOptions.map((option) => {
            return (
              <p key={option}
                className={`vetting-single-option ${option == props.selectedValue ? 'vetting-selected-option' : ''}`}
                onClick={() => updateSelectedOption(option, props.inputIdentifier)}>

                {option}
                {option == props.selectedValue ? <VettingGreenTick /> : null}
              </p>
            )
            })
          }
        </div>

        : null
      }
    </div>
  )
}

export default VettingDropDown;